import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import {
  ITaskTemplateVersion,
  TaskTemplateVersion,
} from '@core/entities/task/TaskTemplateVersion'
import { taskTemplateKeys } from '@core/react-query/features/tasks/templates'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useGetTaskTemplateVersion = (
  payload: RequestTypes['getTaskTemplateVersion'],
  options?: UseQueryOptions<
    ITaskTemplateVersion,
    RequestErrorType,
    TaskTemplateVersion
  >,
) => {
  return useQuery({
    select: TaskTemplateVersion.new,
    ...taskTemplateKeys.getTaskTemplateVersion(payload),
    ...options,
  })
}
